import styled from 'styled-components';
import S from '../UI/variables';

export const StyledRecentWrapper = styled.section`
  width: 100%;
  padding-top: 38px;
  padding-bottom: 40px;
  background: #fff;
  @media (min-width: ${S.tablet}) {
    padding-top: 70px;
    padding-bottom: 95px;
  }
`;

export const StyledRecentsTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;

  & > h2 {
    font-family: 'Judson', serif;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    text-transform: lowercase;
    &::first-letter {
      text-transform: uppercase;
    }
    margin-bottom: 12px;
    @media (min-width: ${S.tablet}) {
      font-size: 48px;
      margin-bottom: 16px;
    }
  }
  & > h3 {
    font-size: 14px;
    text-transform: lowercase;
    text-align: center;
    font-weight: 400;
    &::first-letter {
      text-transform: uppercase;
    }
    margin-bottom: 12px;
    max-width: 360px;
    line-height: 1.7em;
    @media (min-width: ${S.tablet}) {
      font-size: 16px;
      margin-bottom: 40px;
      max-width: 484px;
    }
  }
`;
